function attachProductToForm(button, form) {
    let productCode = button.dataset.product
    let productTitle = button.dataset.title
    let ymAction = button.dataset.ymFormAction
    if (productCode) {
        if (form) {
            let input = form.querySelector('.js-product-code');
            if (input) {
                input.value = productCode;
            }
        }
    }
    let parent = form.parentNode;
    let parent2 = parent.parentNode;
    let title = parent2.querySelector('.js-title');
    form.dataset.ymAction = ymAction
    if (title) {
        title.innerHTML = productTitle
    }
}

export { attachProductToForm }